import { Task } from '../models/task.model';
export class TaskGroup {
  id: string;
  name?: string;
  organizationLevelId?: string;
  organizationLevelName?: string;
  addedToMySite?: boolean;
  addedAtSelectedOrgLevel?: boolean;
  aptTasks?: Task[];
}
